import Vue from "vue"
import PerfectScrollbar from "vue-perfect-scrollbar"

Vue.component("PerfectScrollbar", PerfectScrollbar)
